import { Component, Input } from '@angular/core';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss'
})
export class CustomToastComponent {
  @Input() showToast: boolean = false;
  @Input() toastTitle: string = '';
  @Input() toastmessage: string = '';
  @Input() toastStyle: string = '';
  @Input() toastIconStyle: string = '';
  @Input() toastLink: string = '';
  @Input() toastLinkText: string = '';
  @Input() closable: boolean = true;
  @Input() location: string = '';
  @Input() buttonName: string = '';
  constructor(private dataService: DataService) { }
  closeToast() {
    this.showToast = false;
    this.dataService.removeToast$.next(false);
  }
}
